import React, { useEffect } from 'react';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { RouterInput, trpc } from '../../../api/trpc';
import { Button } from 'rsuite';
import { Controller, useForm } from 'react-hook-form';
import { InputWrapper } from '../../common/input-wrapper';
import { intValidation } from '../../../utils/validations';
import { toast } from 'react-toastify';
import { WhisperSpeaker } from '../../../utils/whisper-speaker';
import Popover from 'rsuite/Popover';
import Dropdown from 'rsuite/Dropdown';
import Whisper from 'rsuite/Whisper';

type Form = {
  pageSize: number;
  boostSize: number;
  sessionTime: number;
};

export const OtcRecommendationSettings = () => {
  const {
    data: settings,
    mutate,
    isLoading,
  } = useSWR(['otcRecommendationAdmin.settings'], () =>
    trpc.otcRecommendationAdmin.settings.query(),
  );
  const { trigger: updateSettings } = useSWRMutation(
    ['otcRecommendationAdmin.updateSettings'],
    (
      _k,
      { arg }: { arg: RouterInput['otcRecommendationAdmin']['updateSettings'] },
    ) => trpc.otcRecommendationAdmin.updateSettings.mutate(arg),
  );

  const { control, handleSubmit, formState, reset } = useForm<Form>();

  const renderSortMenu =
    (): WhisperSpeaker =>
    ({ onClose, left, top, className }, ref) => {
      const handleSelect = async (eventKey: number | string | undefined) => {
        onClose();
        if (settings) {
          if (eventKey === 'weight') {
            await updateSettings({ ...settings, sortType: 'weight' });
            mutate();
          }
          if (eventKey === 'publicWeight') {
            await updateSettings({ ...settings, sortType: 'publicWeight' });
            mutate();
          }
        }
      };

      return (
        <Popover ref={ref} className={className} style={{ left, top }} full>
          <Dropdown.Menu onSelect={handleSelect}>
            <Dropdown.Item eventKey={'weight'}>
              <span className="ps-2">Внутренний вес</span>
            </Dropdown.Item>
            <Dropdown.Item eventKey={'publicWeight'}>
              <span className="ps-2">Внешний вес</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Popover>
      );
    };

  useEffect(() => {
    if (settings) {
      reset(settings);
    }
  }, [settings]);

  return (
    <>
      <form
        id="otcRecommendationSettings"
        className={'d-flex gap-2 w-100'}
        onSubmit={handleSubmit(async (data) => {
          await updateSettings(data);
          mutate();
          toast.success('Настройки обновлены');
        })}
      >
        <Controller
          name="pageSize"
          control={control}
          rules={{
            required: 'Укажите кол-во',
            ...intValidation,
          }}
          render={({ field, fieldState }) => {
            return (
              <InputWrapper
                title="Кол-во рекомендаций"
                error={fieldState.error?.message}
              >
                <input
                  className="form-control"
                  placeholder="Количество рек."
                  {...field}
                  onChange={(e) => field.onChange(+e.target.value)}
                />
              </InputWrapper>
            );
          }}
        />
        <Controller
          name="boostSize"
          control={control}
          rules={{
            required: 'Укажите кол-во(разгон)',
            ...intValidation,
          }}
          render={({ field, fieldState }) => {
            return (
              <InputWrapper
                title="Кол-во рекомендаций - разгон"
                error={fieldState.error?.message}
              >
                <input
                  className="form-control"
                  placeholder="Разгон"
                  {...field}
                  onChange={(e) => field.onChange(+e.target.value)}
                />
              </InputWrapper>
            );
          }}
        />
        <Controller
          name="sessionTime"
          control={control}
          rules={{
            required: 'Укажите минуты',
            ...intValidation,
          }}
          render={({ field, fieldState }) => {
            return (
              <InputWrapper
                title="Длительность сессии (в минутах)"
                error={fieldState.error?.message}
              >
                <input
                  className="form-control"
                  placeholder="Длительность"
                  {...field}
                  onChange={(e) => field.onChange(+e.target.value)}
                />
              </InputWrapper>
            );
          }}
        />{' '}
        <div className={'align-content-end'}>
          <Button type="submit" className="btn btn-success">
            {formState.isSubmitting || isLoading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Сохранить'
            )}
          </Button>
        </div>
        <div className="d-flex  align-self-end mleft-auto">
          <Whisper
            placement="rightStart"
            trigger="click"
            speaker={renderSortMenu()}
          >
            <Button type="button" className="btn btn-light border mleft-auto ">
              Отображать по:{' '}
              {settings?.sortType === 'weight'
                ? 'Внутренний вес'
                : 'Внешний вес'}
            </Button>
          </Whisper>
        </div>
      </form>
    </>
  );
};
